module.exports = __webpack_public_path__ + "static/media/Turkey.e80fb8ec.png";